export default "__VITE_ASSET__CXeXS6uW__"